// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import * as CodeLinkUtils from '@app/features/messaging/utils/CodeLinkUtils';
import {isProbablyAValidSnowflake} from '@fluxer/snowflake/src/SnowflakeUtils';

// Micup: a link to a feed post in a message shows a card of the post, like an invite link does.
export const MAX_FEED_POST_CARDS = 3;

const OFFICIAL_FEED_POST_URL_BASES = Object.freeze(['https://micup.gg/feed/posts', 'https://www.micup.gg/feed/posts']);
const appendFeedPostPath = (endpoint: string | null | undefined): string | null => {
	if (!endpoint) return null;
	const trimmed = endpoint.replace(/\/$/, '');
	return trimmed ? `${trimmed}/feed/posts` : null;
};
const FEED_POST_CONFIG: CodeLinkUtils.CodeLinkConfig = {
	path: 'feed/posts',
	get urlBases() {
		return [
			appendFeedPostPath(RuntimeConfig.webAppBaseUrl),
			appendFeedPostPath(RuntimeConfig.marketingEndpoint),
			...OFFICIAL_FEED_POST_URL_BASES,
		];
	},
};

// The host must start the link, so evilmicup.gg or evil.com/micup.gg never reads as Micup's.
const HOST_CONTINUATION = /[a-zA-Z0-9_.\-/@?=&#%+~:\u0080-\uFFFF]/;

function isPostLink(content: string, match: CodeLinkUtils.CodeLinkMatch): boolean {
	return (
		!match.shortLink &&
		isProbablyAValidSnowflake(match.code) &&
		!HOST_CONTINUATION.test(content.charAt(match.index - 1))
	);
}

export function findFeedPostIds(content: string | null): Array<string> {
	if (!content) return [];
	return CodeLinkUtils.findCodeMatches(content, FEED_POST_CONFIG)
		.filter((match) => isPostLink(content, match))
		.slice(0, MAX_FEED_POST_CARDS)
		.map((match) => match.code);
}

export function findSpoileredFeedPosts(content: string | null): Array<CodeLinkUtils.CodeLinkMatch> {
	if (!content) return [];
	return CodeLinkUtils.findSpoileredCodeMatches(content, FEED_POST_CONFIG).filter((match) =>
		isPostLink(content, match),
	);
}
